import loader from '../assets/loader.gif'

function Loader() {

    return(
        <div className="flex justify-center items-center bg-black fixed top-0 left-0 h-screen w-screen bg-opacity-60 z-30">
            <img src={loader} width={'50px'} height={'50px'} />
        </div>
    )
}

export default Loader;